import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material/material.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { QuestionnaireAddTemplateDialogComponent } from './questionnaire-add-template-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    InputModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [QuestionnaireAddTemplateDialogComponent],
  exports: [QuestionnaireAddTemplateDialogComponent],
  entryComponents: [QuestionnaireAddTemplateDialogComponent]
})
export class QuestionnaireAddTemplateDialogModule { }
